import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instanceat14thlj150z as Unit_instance,
  contentEquals2jbsaphs7gxql as contentEquals,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  intArrayIterator15bt84fheeonh as intArrayIterator,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  contentEquals379bkuxwxaiqz as contentEquals_0,
  contentHashCode2dpr73siofp13 as contentHashCode_0,
  floatArrayIteratortsocm2kbztk as floatArrayIterator,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  println2shhhgwwt4c61 as println,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  reverse2o3etdk6ug8y7 as reverse,
  copyOfq9pcgcgbldck as copyOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isFloatArrayjjscnqphw92j as isFloatArray,
  createThis2j2avj17cvnv2 as createThis,
  takeg3iw3d2yd8b4 as take,
  equals2au1ep9vhcato as equals,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Collection1k04j3hzsbod0 as Collection,
  isIntArrayeijsubfngq38 as isIntArray,
  copyOf3rutauicler23 as copyOf_0,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  take8rd02inxauy8 as take_0,
  copyOfgossjg6lh6js as copyOf_1,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  takei63g8tyo7wy9 as take_1,
  asList2ho2pewtsfvv as asList,
  compareTo3ankvs086tmwq as compareTo,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  toList3jhuyej2anx2q as toList,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  to2cs3ny02qtbcb as to,
  KtMap140uvy3s5zad8 as KtMap,
  hashCodeq5arwsb9dgti as hashCode,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  AbstractMutableSetthfi6jds1k2h as AbstractMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  until1jbpn0z3f8lbg as until,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  joinToString1cxrrlmo0chqs as joinToString,
  Iterable1y3qizuf89iou as Iterable,
  copyOf2ng0t8oizk6it as copyOf_2,
  toString30pk9tzaqopn as toString_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  reversed3cb5fwpceefdb as reversed,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  toSet2orjxp16sotqu as toSet,
  contentEqualsaf55p28mnw74 as contentEquals_1,
  contentHashCode2i020q5tbeh2s as contentHashCode_1,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toRawBits2035dtuolth0v as toRawBits,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  step18s9qzr5xwxat as step,
  arrayCopytctsywo3h7gj as arrayCopy,
  round2mrvepag8eey0 as round,
  toList383f556t1dixk as toList_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ilog23dbvpk38jf7rc as ilog2,
  umod164hvijxhfi8p as umod,
  ilog2Ceil34a3ub1n8578t as ilog2Ceil,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  appendNice3hizhj9kone09 as appendNice,
  appendGenericArray5krccch8fjd0 as appendGenericArray,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  listIterator247sl90ooi4qv as listIterator,
  DoubleList2honu8rif2roh as DoubleList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  Mixin3lmkm5hum2vdj as Mixin,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  IDoubleVectorListoa05cse3he2p as IDoubleVectorList,
  IPointListz7raskb2mrxa as IPointList,
  isNotEmptyrwyeygz7izwg as isNotEmpty,
  isAlmostEquals2qd88bwpjj4z5 as isAlmostEquals,
  containsAll194lepx84fvib as containsAll,
  iterator1sm8hwbj0nmg8 as iterator,
  listIteratorrk3szyua4uzm as listIterator_0,
  listIterator3ooh2yjav3kr9 as listIterator_1,
  subList2funs4qwcrhhq as subList,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {}
class IArray2 {}
function inside(x, y) {
  return x >= 0 && y >= 0 && x < this.k2l() && y < this.l2l();
}
function getAt(x, y) {
  return this.s2l(x, y) ? this.xy(indexOr(this, x, y)) : this.xy(0);
}
function asString() {
  var tmp = until(0, this.l2l());
  return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
}
class IntIArray2 {}
function get(x, y) {
  return this.n2l(indexOr(this, x, y));
}
function set(x, y, value) {
  return this.o2l(indexOr(this, x, y), value);
}
function getAt_0(idx) {
  return this.n2l(idx);
}
class IntArray2 {
  constructor(width, height, data) {
    this.h2l_1 = width;
    this.i2l_1 = height;
    this.j2l_1 = data;
    Companion_instance_4.m2l(this.k2l(), this.l2l(), this.j2l_1.length);
  }
  k2l() {
    return this.h2l_1;
  }
  l2l() {
    return this.i2l_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.k2l() === other.k2l();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.l2l() === other.l2l();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.j2l_1, other.j2l_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  n2l(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.j2l_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.IntArray2.getFast.<anonymous>' call
      tmp = this.j2l_1[0];
    }
    return tmp;
  }
  o2l(idx, value) {
    if (0 <= idx ? idx <= (this.j2l_1.length - 1 | 0) : false) {
      this.j2l_1[idx] = value;
    }
  }
  hashCode() {
    return (this.k2l() + this.l2l() | 0) + contentHashCode(this.j2l_1) | 0;
  }
  a1() {
    return intArrayIterator(this.j2l_1);
  }
  toString() {
    return this.p2l();
  }
}
class Companion_0 {}
class FloatIArray2 {}
function get_0(x, y) {
  return this.n2l(indexOr(this, x, y));
}
function set_0(x, y, value) {
  return this.w2l(indexOr(this, x, y), value);
}
function getAt_1(idx) {
  return this.n2l(idx);
}
class FloatArray2 {
  constructor(width, height, data) {
    this.t2l_1 = width;
    this.u2l_1 = height;
    this.v2l_1 = data;
    Companion_instance_4.m2l(this.k2l(), this.l2l(), this.v2l_1.length);
  }
  k2l() {
    return this.t2l_1;
  }
  l2l() {
    return this.u2l_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof FloatArray2) {
      tmp_1 = this.k2l() === other.k2l();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.l2l() === other.l2l();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_0(this.v2l_1, other.v2l_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  n2l(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.v2l_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      // Inline function 'korlibs.datastructure.FloatArray2.getFast.<anonymous>' call
      tmp = 0.0;
    }
    return tmp;
  }
  w2l(idx, value) {
    if (0 <= idx ? idx <= (this.v2l_1.length - 1 | 0) : false) {
      this.v2l_1[idx] = value;
    }
  }
  hashCode() {
    return (this.k2l() + this.l2l() | 0) + contentHashCode_0(this.v2l_1) | 0;
  }
  a1() {
    return floatArrayIterator(this.v2l_1);
  }
  toString() {
    return this.p2l();
  }
}
class ByteArrayDeque {
  constructor(initialBits, allowGrow) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.g2m_1 = initialBits;
    this.h2m_1 = allowGrow;
    this.i2m_1 = new RingBuffer(this.g2m_1);
    this.j2m_1 = new Int8Array(1024);
    this.k2m_1 = new Long(0, 0);
    this.l2m_1 = new Long(0, 0);
  }
  w14() {
    return this.i2m_1.f2m_1;
  }
  x14(buffer, offset, size) {
    ensureWrite(this, size);
    var out = this.i2m_1.x14(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.k2m_1 = this.k2m_1.r3(toLong(out));
    }
    return out;
  }
  n2m(buffer, offset, size, $super) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? buffer.length - offset | 0 : size;
    return $super === VOID ? this.x14(buffer, offset, size) : $super.x14.call(this, buffer, offset, size);
  }
  m15(count) {
    return this.i2m_1.m15(count);
  }
  l15(buffer, offset, size) {
    return this.i2m_1.l15(buffer, offset, size);
  }
  e3() {
    this.i2m_1.e3();
  }
  hashCode() {
    return this.i2m_1.z14();
  }
  equals(other) {
    var tmp;
    if (other instanceof ByteArrayDeque) {
      tmp = this.i2m_1.equals(other.i2m_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ShortArrayDeque {
  constructor(initialBits) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    this.x2m_1 = initialBits;
    this.y2m_1 = new ShortRingBuffer(this.x2m_1);
    this.z2m_1 = new Int16Array(1024);
    this.a2n_1 = new Long(0, 0);
    this.b2n_1 = new Long(0, 0);
  }
  w14() {
    return this.y2m_1.v2m_1;
  }
  d2n(buffer, offset, size) {
    var out = ensureWrite_0(this, size).y2m_1.d2n(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.a2n_1 = this.a2n_1.r3(toLong(out));
    }
    return out;
  }
  c2n(buffer, offset, size) {
    var out = this.y2m_1.c2n(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.b2n_1 = this.b2n_1.r3(toLong(out));
    }
    return out;
  }
  e3() {
    this.y2m_1.e3();
  }
  e2n() {
    this.c2n(this.z2m_1, 0, 1);
    return this.z2m_1[0];
  }
  f2n(value) {
    this.z2m_1[0] = value;
    this.d2n(this.z2m_1, 0, 1);
  }
  hashCode() {
    return this.y2m_1.z14();
  }
  equals(other) {
    var tmp;
    if (other instanceof ShortArrayDeque) {
      tmp = this.y2m_1.equals(other.y2m_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Companion_1 {}
class FloatArrayList {
  static i2n(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float32Array(capacity);
    tmp.g2n_1 = isFloatArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.h2n_1 = 0;
    return $this;
  }
  gu(value) {
    ensure(this, value);
    this.h2n_1 = value;
  }
  e1() {
    return this.h2n_1;
  }
  static j2n(other) {
    var $this = this.i2n();
    $this.k2n(other);
    return $this;
  }
  e3() {
    this.h2n_1 = 0;
  }
  l2n(v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this.g2n_1;
    var _unary__edvuaz = this.h2n_1;
    this.h2n_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.g2n_1;
    var _unary__edvuaz_0 = this.h2n_1;
    this.h2n_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.g2n_1;
    var _unary__edvuaz_1 = this.h2n_1;
    this.h2n_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.g2n_1;
    var _unary__edvuaz_2 = this.h2n_1;
    this.h2n_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  m2n(values, offset, length) {
    ensure(this, length);
    var tmp = Memory_instance;
    tmp.n2n(isFloatArray(values) ? values : THROW_CCE(), offset, this.g2n_1, this.e1(), length);
    this.gu(this.e1() + length | 0);
  }
  k2n(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.m2n(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.m2n.call(this, values, offset, length);
    }
    return tmp;
  }
  xy(index) {
    return this.g2n_1[index];
  }
  a1() {
    return this.v2(0);
  }
  o2n(element) {
    var inductionVariable = 0;
    var last = this.h2n_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.g2n_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  p2n(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.o2n(e))
        return false;
    }
    return true;
  }
  t2(elements) {
    return this.p2n(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  q2n() {
    return copyOf(this.g2n_1, this.h2n_1);
  }
  v2(index) {
    return take(this.g2n_1, this.h2n_1).v2(index);
  }
  hashCode() {
    return contentHashCode_2(this.g2n_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof FloatArrayList)
      return this.e1() === other.e1() && contentEquals_2(this.g2n_1, other.g2n_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.zb(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FloatArrayList.toString.<anonymous>' call
    this_0.vb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ub(', ');
        }
        this_0.zg(this.xy(n));
      }
       while (inductionVariable < last);
    this_0.vb(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_2 {}
class IntArrayList {
  static t2n(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Int32Array(capacity);
    tmp.r2n_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.s2n_1 = 0;
    return $this;
  }
  gu(value) {
    this.u2n(value);
    this.s2n_1 = value;
  }
  e1() {
    return this.s2n_1;
  }
  static v2n(other) {
    var $this = this.t2n();
    $this.w2n(other);
    return $this;
  }
  static x2n(other) {
    var $this = this.t2n();
    $this.y2n(other);
    return $this;
  }
  u2n(count) {
    if ((this.s2n_1 + count | 0) > this.r2n_1.length) {
      var tmp = this;
      var tmp_0 = this.r2n_1;
      // Inline function 'kotlin.math.max' call
      var a = this.s2n_1 + count | 0;
      var b = imul(this.r2n_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
      tmp.r2n_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  e3() {
    this.s2n_1 = 0;
  }
  z2n(v0) {
    this.u2n(1);
    var tmp = this.r2n_1;
    var _unary__edvuaz = this.s2n_1;
    this.s2n_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  a2o(value) {
    return this.z2n(value);
  }
  b2o(value) {
    return this.w2n(value);
  }
  c2o(values, offset, length) {
    this.u2n(length);
    var tmp = Memory_instance;
    tmp.d2o(isIntArray(values) ? values : THROW_CCE(), offset, this.r2n_1, this.e1(), length);
    this.gu(this.e1() + length | 0);
  }
  y2n(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.c2o(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.c2o.call(this, values, offset, length);
    }
    return tmp;
  }
  w2n(values) {
    return this.c2o(values.r2n_1, 0, values.e1());
  }
  d1(index) {
    return this.r2n_1[index];
  }
  xy(index) {
    return this.r2n_1[index];
  }
  e2o(index, value) {
    if (index >= this.s2n_1) {
      this.u2n(index + 1 | 0);
      this.s2n_1 = index + 1 | 0;
    }
    this.r2n_1[index] = value;
  }
  a1() {
    return this.v2(0);
  }
  cp(element) {
    var inductionVariable = 0;
    var last = this.s2n_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.r2n_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  f2o(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.cp(e))
        return false;
    }
    return true;
  }
  t2(elements) {
    return this.f2o(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  e2b() {
    return !(this.e1() === 0);
  }
  nk() {
    var tmp;
    if (this.g1()) {
      throw IndexOutOfBoundsException.fe();
    } else {
      tmp = this.r2n_1[0];
    }
    return tmp;
  }
  g2o() {
    var tmp;
    if (this.g1()) {
      throw IndexOutOfBoundsException.fe();
    } else {
      tmp = this.r2n_1[this.s2n_1 - 1 | 0];
    }
    return tmp;
  }
  h2o(index, value) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.insertAt.<anonymous>' call
    this.u2n(1);
    if (this.e2b()) {
      Memory_instance.d2o(this.r2n_1, index, this.r2n_1, index + 1 | 0, this.s2n_1 - index | 0);
    }
    this.r2n_1[index] = value;
    this.s2n_1 = this.s2n_1 + 1 | 0;
    return this;
  }
  i2o(indexA, indexB) {
    var l = this.xy(indexA);
    var r = this.xy(indexB);
    this.e2o(indexA, r);
    this.e2o(indexB, l);
  }
  j2o(index, count) {
    if (index < 0 || index >= this.s2n_1 || (index + count | 0) > this.s2n_1)
      throw IndexOutOfBoundsException.fe();
    var out = this.r2n_1[index];
    if (count > 0) {
      if (index < (this.s2n_1 - count | 0)) {
        Memory_instance.d2o(this.r2n_1, index + count | 0, this.r2n_1, index, (this.s2n_1 - index | 0) - count | 0);
      }
      this.s2n_1 = this.s2n_1 - count | 0;
    }
    return out;
  }
  k2o() {
    return copyOf_0(this.r2n_1, this.s2n_1);
  }
  v2(index) {
    return take_0(this.r2n_1, this.s2n_1).v2(index);
  }
  hashCode() {
    return contentHashCode_3(this.r2n_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof IntArrayList)
      return this.e1() === other.e1() && contentEquals_3(this.r2n_1, other.r2n_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.zb(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.toString.<anonymous>' call
    this_0.vb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ub(', ');
        }
        this_0.xg(this.xy(n));
      }
       while (inductionVariable < last);
    this_0.vb(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_3 {}
class DoubleArrayList {
  static n2o(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float64Array(capacity);
    tmp.l2o_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.m2o_1 = 0;
    return $this;
  }
  gu(value) {
    ensure_0(this, value);
    this.m2o_1 = value;
  }
  e1() {
    return this.m2o_1;
  }
  static o2o(other) {
    var $this = this.n2o();
    $this.p2o(other);
    return $this;
  }
  static q2o(other) {
    var $this = this.n2o();
    $this.r2o(other);
    return $this;
  }
  e3() {
    this.m2o_1 = 0;
  }
  u10(v0) {
    ensure_0(this, 1);
    var tmp = this.l2o_1;
    var _unary__edvuaz = this.m2o_1;
    this.m2o_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  s2o(v0, v1) {
    ensure_0(this, 2);
    var tmp = this.l2o_1;
    var _unary__edvuaz = this.m2o_1;
    this.m2o_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.l2o_1;
    var _unary__edvuaz_0 = this.m2o_1;
    this.m2o_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
  }
  t2o(v0, v1, v2, v3) {
    ensure_0(this, 4);
    var tmp = this.l2o_1;
    var _unary__edvuaz = this.m2o_1;
    this.m2o_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.l2o_1;
    var _unary__edvuaz_0 = this.m2o_1;
    this.m2o_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.l2o_1;
    var _unary__edvuaz_1 = this.m2o_1;
    this.m2o_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.l2o_1;
    var _unary__edvuaz_2 = this.m2o_1;
    this.m2o_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  u2o(v0, v1, v2, v3, v4, v5) {
    ensure_0(this, 6);
    var tmp = this.l2o_1;
    var _unary__edvuaz = this.m2o_1;
    this.m2o_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.l2o_1;
    var _unary__edvuaz_0 = this.m2o_1;
    this.m2o_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.l2o_1;
    var _unary__edvuaz_1 = this.m2o_1;
    this.m2o_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.l2o_1;
    var _unary__edvuaz_2 = this.m2o_1;
    this.m2o_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.l2o_1;
    var _unary__edvuaz_3 = this.m2o_1;
    this.m2o_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.l2o_1;
    var _unary__edvuaz_4 = this.m2o_1;
    this.m2o_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  v2o(value) {
    return this.u10(value);
  }
  w2o(value) {
    return this.p2o(value);
  }
  x2o(values, offset, length) {
    ensure_0(this, length);
    var tmp = Memory_instance;
    tmp.y2o(isDoubleArray(values) ? values : THROW_CCE(), offset, this.l2o_1, this.e1(), length);
    this.gu(this.e1() + length | 0);
  }
  r2o(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.x2o(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.x2o.call(this, values, offset, length);
    }
    return tmp;
  }
  p2o(values) {
    return this.x2o(values.l2o_1, 0, values.e1());
  }
  d1(index) {
    return this.l2o_1[index];
  }
  xy(index) {
    return this.l2o_1[index];
  }
  z2o(index, value) {
    if (index >= this.m2o_1) {
      ensure_0(this, index + 1 | 0);
      this.m2o_1 = index + 1 | 0;
    }
    this.l2o_1[index] = value;
  }
  a1() {
    return this.v2(0);
  }
  a2p(element) {
    var inductionVariable = 0;
    var last = this.m2o_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.l2o_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  az(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      if (!this.a2p(e))
        return false;
    }
    return true;
  }
  t2(elements) {
    return this.az(elements);
  }
  g1() {
    return this.e1() === 0;
  }
  i2o(indexA, indexB) {
    var l = this.xy(indexA);
    var r = this.xy(indexB);
    this.z2o(indexA, r);
    this.z2o(indexB, l);
  }
  i3(index) {
    return this.j2o(index, 1);
  }
  j2o(index, count) {
    if (index < 0 || index >= this.m2o_1 || (index + count | 0) > this.m2o_1)
      throw IndexOutOfBoundsException.fe();
    var out = this.l2o_1[index];
    if (count > 0) {
      if (index < (this.m2o_1 - count | 0)) {
        Memory_instance.y2o(this.l2o_1, index + count | 0, this.l2o_1, index, (this.m2o_1 - index | 0) - count | 0);
      }
      this.m2o_1 = this.m2o_1 - count | 0;
    }
    return out;
  }
  yy() {
    return copyOf_1(this.l2o_1, this.m2o_1);
  }
  v2(index) {
    return take_1(this.l2o_1, this.m2o_1).v2(index);
  }
  w2(fromIndex, toIndex) {
    // Inline function 'kotlin.collections.asList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.l2o_1;
    return asList(tmp$ret$1).w2(fromIndex, toIndex);
  }
  zy() {
    return DoubleArrayList.o2o(this);
  }
  hashCode() {
    return contentHashCode_4(this.l2o_1, 0, this.e1());
  }
  equals(other) {
    if (other instanceof DoubleArrayList)
      return this.e1() === other.e1() && contentEquals_4(this.l2o_1, other.l2o_1, 0, this.e1());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.zb(2 + imul(5, this.e1()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    this_0.vb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ub(', ');
        }
        this_0.ah(this.xy(n));
      }
       while (inductionVariable < last);
    this_0.vb(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class SortOps {
  g2p(subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last = indexL + 1 | 0;
    if (last <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.f2p(subject, n - 1 | 0, n);
      }
       while (!(n === last));
  }
  b2p(subject, indexL, indexR) {
    var count = (indexR - indexL | 0) + 1 | 0;
    var inductionVariable = 0;
    var last = count / 2 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.f2p(subject, indexL + n | 0, indexR - n | 0);
      }
       while (inductionVariable < last);
  }
}
class DoubleArrayListSortOps extends SortOps {
  constructor() {
    DoubleArrayListSortOps_instance = null;
    super();
    DoubleArrayListSortOps_instance = this;
  }
  c2p(subject, l, r) {
    return compareTo(subject.xy(l), subject.xy(r));
  }
  d2p(subject, l, r) {
    return this.c2p(subject instanceof DoubleArrayList ? subject : THROW_CCE(), l, r);
  }
  e2p(subject, indexL, indexR) {
    var l = subject.xy(indexL);
    var r = subject.xy(indexR);
    subject.z2o(indexR, l);
    subject.z2o(indexL, r);
  }
  f2p(subject, indexL, indexR) {
    return this.e2p(subject instanceof DoubleArrayList ? subject : THROW_CCE(), indexL, indexR);
  }
}
class TGenDeque$iterator$1 {
  constructor($that, this$0) {
    this.m2p_1 = $that;
    this.n2p_1 = this$0;
    this.l2p_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.l2p_1;
    this.l2p_1 = _unary__edvuaz + 1 | 0;
    return this.m2p_1.d1(_unary__edvuaz);
  }
  b1() {
    return this.l2p_1 < this.n2p_1.e1();
  }
  k6() {
    this.l2p_1 = this.l2p_1 - 1 | 0;
    this.n2p_1.i3(this.l2p_1);
  }
}
class TGenDeque {
  static o2p(initialCapacity) {
    var $this = createThis(this);
    $this.h2p_1 = 0;
    $this.i2p_1 = 0;
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp.j2p_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static p2p() {
    return this.o2p(16);
  }
  e1() {
    return this.i2p_1;
  }
  g1() {
    return this.e1() === 0;
  }
  q2p(item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  }
  r2p(list) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var count = list.e1();
    resizeIfRequiredFor(this, count);
    var base = this.h2p_1 + this.i2p_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.j2p_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        // Inline function 'korlibs.datastructure.TGenDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.d1(n);
      }
       while (inductionVariable < count);
    this.i2p_1 = this.i2p_1 + count | 0;
    return true;
  }
  s2p(elements) {
    return this.r2p(toList(elements));
  }
  f1(elements) {
    return this.s2p(elements);
  }
  rk() {
    if (this.i2p_1 <= 0)
      throw IndexOutOfBoundsException.fe();
    var out = this.t2p();
    nullify(this, this.h2p_1);
    this.h2p_1 = (this.h2p_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    this.i2p_1 = this.i2p_1 - 1 | 0;
    return out;
  }
  tk() {
    if (this.i2p_1 <= 0)
      throw IndexOutOfBoundsException.fe();
    var out = this.u2p();
    nullify(this, internalIndex(this, this.e1() - 1 | 0));
    this.i2p_1 = this.i2p_1 - 1 | 0;
    return out;
  }
  i3(index) {
    if (index < 0 || index >= this.e1())
      throw IndexOutOfBoundsException.fe();
    if (index === 0)
      return this.rk();
    if (index === (this.e1() - 1 | 0))
      return this.tk();
    var old = this.d1(index);
    if (index < (this.e1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.v2p(n, this.d1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.h2p_1 = umod(this.h2p_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.e1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.v2p(n_0, this.d1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.i2p_1 = this.i2p_1 - 1 | 0;
    return old;
  }
  w2p(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.TGenDeque.add.<anonymous>' call
    this.q2p(element);
    return true;
  }
  h(element) {
    return this.w2p((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  x2p(element) {
    var index = this.y2p(element);
    if (index >= 0) {
      this.i3(index);
    }
    return index >= 0;
  }
  g3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.x2p((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  t2p() {
    return this.j2p_1[this.h2p_1];
  }
  u2p() {
    return this.j2p_1[internalIndex(this, this.e1() - 1 | 0)];
  }
  v2p(index, value) {
    this.j2p_1[internalIndex(this, index)] = value;
  }
  d1(index) {
    return this.j2p_1[internalIndex(this, index)];
  }
  y2p(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.d1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  z2p(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.d1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).x2(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.b3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.f3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  t2(elements) {
    return this.z2p(elements);
  }
  a1() {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.e1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.TGenDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.e1() === this.e1()))
      return false;
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.d1(n), other.d1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.vb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.tb(this.d1(n));
        if (!(n === (this.e1() - 1 | 0))) {
          sb.ub(', ');
        }
      }
       while (inductionVariable < last);
    sb.vb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class IntDeque$iterator$1 {
  constructor($that, this$0) {
    this.e2q_1 = $that;
    this.f2q_1 = this$0;
    this.d2q_1 = 0;
  }
  c1() {
    var _unary__edvuaz = this.d2q_1;
    this.d2q_1 = _unary__edvuaz + 1 | 0;
    return this.e2q_1.d1(_unary__edvuaz);
  }
  b1() {
    return this.d2q_1 < this.f2q_1.e1();
  }
  k6() {
    this.d2q_1 = this.d2q_1 - 1 | 0;
    this.f2q_1.i3(this.d2q_1);
  }
}
class IntDeque {
  static g2q(initialCapacity) {
    var $this = createThis(this);
    $this.a2q_1 = 0;
    $this.b2q_1 = 0;
    var tmp = $this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.c2q_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static h2q() {
    return this.g2q(16);
  }
  e1() {
    return this.b2q_1;
  }
  g1() {
    return this.e1() === 0;
  }
  i2q(item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  }
  j2q(list) {
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var count = list.e1();
    resizeIfRequiredFor_0(this, count);
    var base = this.a2q_1 + this.b2q_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.c2q_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        // Inline function 'korlibs.datastructure.IntDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.d1(n);
      }
       while (inductionVariable < count);
    this.b2q_1 = this.b2q_1 + count | 0;
    return true;
  }
  k2q(elements) {
    return this.j2q(toList(elements));
  }
  f1(elements) {
    return this.k2q(elements);
  }
  rk() {
    if (this.b2q_1 <= 0)
      throw IndexOutOfBoundsException.fe();
    var out = this.t2p();
    nullify_0(this, this.a2q_1);
    this.a2q_1 = (this.a2q_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    this.b2q_1 = this.b2q_1 - 1 | 0;
    return out;
  }
  tk() {
    if (this.b2q_1 <= 0)
      throw IndexOutOfBoundsException.fe();
    var out = this.u2p();
    nullify_0(this, internalIndex_0(this, this.e1() - 1 | 0));
    this.b2q_1 = this.b2q_1 - 1 | 0;
    return out;
  }
  i3(index) {
    if (index < 0 || index >= this.e1())
      throw IndexOutOfBoundsException.fe();
    if (index === 0)
      return this.rk();
    if (index === (this.e1() - 1 | 0))
      return this.tk();
    var old = this.d1(index);
    if (index < (this.e1() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.e2o(n, this.d1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.a2q_1 = umod(this.a2q_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.e1() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.e2o(n_0, this.d1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.b2q_1 = this.b2q_1 - 1 | 0;
    return old;
  }
  l2q(element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntDeque.add.<anonymous>' call
    this.i2q(element);
    return true;
  }
  h(element) {
    return this.l2q((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  m2q(element) {
    var index = this.n2q(element);
    if (index >= 0) {
      this.i3(index);
    }
    return index >= 0;
  }
  g3(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.m2q((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  t2p() {
    return this.c2q_1[this.a2q_1];
  }
  u2p() {
    return this.c2q_1[internalIndex_0(this, this.e1() - 1 | 0)];
  }
  e2o(index, value) {
    this.c2q_1[internalIndex_0(this, index)] = value;
  }
  d1(index) {
    return this.c2q_1[internalIndex_0(this, index)];
  }
  n2q(element) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.d1(n) === element)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  f2o(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.h(tmp$ret$0);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.d1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).x2(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.b3(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.f3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.a1();
      while (tmp0_iterator_0.b1()) {
        var element = tmp0_iterator_0.c1();
        // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  }
  t2(elements) {
    return this.f2o(elements);
  }
  a1() {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.e1();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.IntDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.e1() === this.e1()))
      return false;
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.d1(n) === other.d1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.f();
    sb.vb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.xg(this.d1(n));
        if (!(n === (this.e1() - 1 | 0))) {
          sb.ub(', ');
        }
      }
       while (inductionVariable < last);
    sb.vb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class FastSmallSet extends AbstractMutableSet {
  static s2q() {
    var $this = this.v7();
    $this.o2q_1 = LinkedHashSet.h1();
    $this.p2q_1 = null;
    $this.q2q_1 = null;
    $this.r2q_1 = null;
    return $this;
  }
  e1() {
    return this.o2q_1.e1();
  }
  a1() {
    return this.o2q_1.a1();
  }
  t2q(element) {
    if (this.zk(element))
      return false;
    this.o2q_1.h(element);
    return true;
  }
  h(element) {
    return this.t2q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  u2q(element) {
    this.p2q_1 = null;
    this.q2q_1 = null;
    this.r2q_1 = null;
    this.o2q_1.g3(element);
    return true;
  }
  g3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.u2q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  zk(element) {
    if (element === this.p2q_1 || element === this.q2q_1 || element === this.p2q_1)
      return true;
    var result = this.o2q_1.s2(element);
    if (result) {
      this.q2q_1 = this.p2q_1;
      this.r2q_1 = this.q2q_1;
      this.p2q_1 = element;
    }
    return result;
  }
  s2(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.zk((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  e3() {
    this.o2q_1.e3();
    this.p2q_1 = null;
    this.q2q_1 = null;
    this.r2q_1 = null;
  }
}
class GenericSubList {
  constructor(base, start, end) {
    this.v2q_1 = base;
    this.w2q_1 = start;
    this.x2q_1 = end;
    var containsUpper = this.v2q_1.e1();
    var containsArg = this.w2q_1;
    if (!(0 <= containsArg ? containsArg <= containsUpper : false))
      throw IndexOutOfBoundsException.ge('' + this.w2q_1);
    var containsUpper_0 = this.v2q_1.e1();
    var containsArg_0 = this.x2q_1;
    if (!(0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false))
      throw IndexOutOfBoundsException.ge('' + this.x2q_1);
  }
  e1() {
    return this.x2q_1 - this.w2q_1 | 0;
  }
  al(elements) {
    var elementsSet = toMutableSet(elements);
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.minusAssign' call
        var element = this.d1(n);
        elementsSet.g3(element);
      }
       while (inductionVariable < last);
    return elementsSet.g1();
  }
  t2(elements) {
    return this.al(elements);
  }
  d1(index) {
    return this.v2q_1.d1(translateIndex(index, this));
  }
  g1() {
    return this.e1() === 0;
  }
  a1() {
    return new GenericListIterator(this);
  }
  u2() {
    return new GenericListIterator(this);
  }
  v2(index) {
    return new GenericListIterator(this, index);
  }
  w2(fromIndex, toIndex) {
    return new GenericSubList(this, fromIndex, toIndex);
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.w1_1;
    var last = this_0.x1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.GenericSubList.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.d1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return toString(destination);
  }
  equals(other) {
    var tmp;
    if (other instanceof GenericSubList) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.e1();
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.GenericSubList.equals.<anonymous>' call
            if (!equals(this.d1(n), other.d1(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.e1();
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.GenericSubList.hashCode.<anonymous>' call
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.d1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class GenericListIterator {
  constructor(list, iindex) {
    iindex = iindex === VOID ? 0 : iindex;
    this.y2q_1 = list;
    this.z2q_1 = iindex;
    var containsUpper = this.y2q_1.e1();
    var containsArg = this.z2q_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException.ge('' + this.z2q_1);
    this.a2r_1 = this.z2q_1;
  }
  b1() {
    return this.a2r_1 < this.y2q_1.e1();
  }
  c1() {
    if (!this.b1())
      throw NoSuchElementException.o6();
    var _unary__edvuaz = this.a2r_1;
    this.a2r_1 = _unary__edvuaz + 1 | 0;
    return this.y2q_1.d1(_unary__edvuaz);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals(this.y2q_1, other.y2q_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.a2r_1 === other.a2r_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.y2q_1) + this.a2r_1 | 0;
  }
}
class Companion_4 {
  m2l(width, height, arraySize) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(arraySize >= imul(width, height))) {
      // Inline function 'korlibs.datastructure.Companion.checkArraySize.<anonymous>' call
      var message = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      throw IllegalStateException.a5(toString(message));
    }
  }
}
class Companion_5 {
  constructor() {
    this.r2r_1 = 2147483646;
    this.s2r_1 = 2147483647;
    this.t2r_1 = 0;
  }
}
class Entry {
  constructor(key, value) {
    this.x2r_1 = key;
    this.y2r_1 = value;
  }
  toString() {
    return 'Entry(key=' + this.x2r_1 + ', value=' + toString_0(this.y2r_1) + ')';
  }
  hashCode() {
    var result = this.x2r_1;
    result = imul(result, 31) + (this.y2r_1 == null ? 0 : hashCode(this.y2r_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.x2r_1 === tmp0_other_with_cast.x2r_1))
      return false;
    if (!equals(this.y2r_1, tmp0_other_with_cast.y2r_1))
      return false;
    return true;
  }
}
class Iterator {
  constructor(map) {
    this.b2r_1 = map;
    this.c2r_1 = this.b2r_1.h2r_1 ? 2147483647 : nextNonEmptyIndex(this, this.b2r_1.l2r_1, 0);
    this.d2r_1 = new Entry(0, null);
  }
  b1() {
    return !(this.c2r_1 === 2147483646);
  }
  p2r() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentKey(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextKey.<anonymous>' call
    next(this);
    return this_0;
  }
  q2r() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentValue(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextValue.<anonymous>' call
    next(this);
    return this_0;
  }
}
class _no_name_provided__qut3iv {
  constructor(this$0) {
    this.z2r_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.z2r_1);
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(it);
    return Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(it));
  }
}
class _no_name_provided__qut3iv_0 {
  constructor(this$0) {
    this.a2s_1 = this$0;
  }
  a1() {
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.a2s_1);
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(it);
    return Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(it));
  }
}
class IntMap {
  static u2r(nbits, loadFactor, dummy) {
    dummy = dummy === VOID ? false : dummy;
    var $this = createThis(this);
    $this.e2r_1 = nbits;
    $this.f2r_1 = loadFactor;
    $this.g2r_1 = 1 << $this.e2r_1;
    $this.h2r_1 = false;
    $this.i2r_1 = null;
    $this.j2r_1 = $this.g2r_1 - 1 | 0;
    $this.k2r_1 = 1 + imul($this.e2r_1, $this.e2r_1) | 0;
    $this.l2r_1 = new Int32Array($this.w2r());
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.w2r();
    var tmp_0 = fillArrayVal(Array(size), null);
    tmp.m2r_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.n2r_1 = numberToInt($this.g2r_1 * $this.f2r_1);
    $this.o2r_1 = 0;
    return $this;
  }
  static b2s(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.u2r(tmp$ret$0, loadFactor, true);
  }
  w2r() {
    return this.g2r_1 + this.k2r_1 | 0;
  }
  d1(key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this.i2r_1;
    return this.m2r_1[index];
  }
  v2r(key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.h2r_1 = true;
          this.i2r_1 = value;
          this.o2r_1 = this.o2r_1 + 1 | 0;
          return null;
        }
        if (this.o2r_1 >= this.n2r_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        if (this.l2r_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.l2r_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.l2r_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.l2r_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.l2r_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.k2r_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.i2r_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.i2r_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.m2r_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.m2r_1[index] = value;
        return this_1;
      }
    }
  }
  a3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(this);
  }
  f3() {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(this);
  }
  c2s(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.h2r_1 ? 2147483647 : this.c2s(this.l2r_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.l2r_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.equals.<anonymous>' call
      var key = it;
      var value = this.d1(it);
      if (!equals(other.d1(key), value))
        return false;
      index = this.c2s(this.l2r_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.h2r_1 ? 2147483647 : this.c2s(this.l2r_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.l2r_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.hashCode.<anonymous>' call
      var tmp = out;
      var tmp_0 = it;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.d1(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) | 0;
      index = this.c2s(this.l2r_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Companion_6 {
  constructor() {
    this.d2s_1 = 2147483646;
    this.e2s_1 = 2147483647;
    this.f2s_1 = 0;
  }
}
class IntIntMap {
  static r2s(nbits, loadFactor, dummy) {
    var $this = createThis(this);
    $this.g2s_1 = nbits;
    $this.h2s_1 = loadFactor;
    $this.i2s_1 = 1 << $this.g2s_1;
    $this.j2s_1 = false;
    $this.k2s_1 = 0;
    $this.l2s_1 = $this.i2s_1 - 1 | 0;
    $this.m2s_1 = 1 + imul($this.g2s_1, $this.g2s_1) | 0;
    $this.n2s_1 = new Int32Array($this.w2r());
    $this.o2s_1 = new Int32Array($this.w2r());
    $this.p2s_1 = numberToInt($this.i2s_1 * $this.h2s_1);
    $this.q2s_1 = 0;
    return $this;
  }
  static t2s(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.r2s(tmp$ret$0, loadFactor, true);
  }
  toString() {
    return toString(this.u2s());
  }
  w2r() {
    return this.i2s_1 + this.m2s_1 | 0;
  }
  v2s(out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.j2s_1 ? 2147483647 : this.c2s(this.n2s_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.n2s_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.toMap.<anonymous>' call
      var key = it;
      // Inline function 'kotlin.collections.set' call
      var value = this.d1(it);
      out.b3(key, value);
      index = this.c2s(this.n2s_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
  u2s(out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.v2s(out) : $super.v2s.call(this, out);
  }
  cp(key) {
    return _getKeyIndex_0(this, key) >= 0;
  }
  e3() {
    this.j2s_1 = false;
    this.k2s_1 = 0;
    fill(this.n2s_1, 0);
    fill(this.o2s_1, 0);
    this.q2s_1 = 0;
  }
  d1(key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return 0;
    if (index === 2147483647)
      return this.k2s_1;
    return this.o2s_1[index];
  }
  s2s(key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this.j2s_1 = true;
          this.k2s_1 = value;
          this.q2s_1 = this.q2s_1 + 1 | 0;
          return 0;
        }
        if (this.q2s_1 >= this.p2s_1) {
          grow_0(this);
        }
        var index1 = hash1_0(this, key);
        if (this.n2s_1[index1] === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        if (this.n2s_1[index2] === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        if (this.n2s_1[index3] === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu_0(this);
        var last = this.n2s_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.n2s_1[n] === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.m2s_1 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.k2s_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.k2s_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.o2s_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.o2s_1[index] = value;
        return this_1;
      }
    }
  }
  c2s(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntIntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.j2s_1 ? 2147483647 : this.c2s(this.n2s_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.n2s_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.equals.<anonymous>' call
      var key = it;
      var value = this.d1(it);
      if (!(other.d1(key) === value))
        return false;
      index = this.c2s(this.n2s_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.j2s_1 ? 2147483647 : this.c2s(this.n2s_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.n2s_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.hashCode.<anonymous>' call
      out = out + (it + this.d1(it) | 0) | 0;
      index = this.c2s(this.n2s_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Iterator$1 {
  constructor($hasNext, $next) {
    this.w2s_1 = $hasNext;
    this.x2s_1 = $next;
  }
  b1() {
    return this.w2s_1();
  }
  c1() {
    return this.x2s_1();
  }
}
class Companion_7 {}
class Pool {
  static c2t(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = createThis(this);
    $this.y2s_1 = reset;
    $this.z2s_1 = gen;
    $this.a2t_1 = _TGenStack___init__impl__yynjgt();
    $this.b2t_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $this.b2t_1;
        $this.b2t_1 = _unary__edvuaz + 1 | 0;
        TGenStack__push_impl_9yh33t($this.a2t_1, $this.z2s_1(_unary__edvuaz));
      }
       while (inductionVariable < preallocate);
    return $this;
  }
  static d2t(preallocate, gen) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    return this.c2t(Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
  }
  e2t() {
    return _TGenStack___get_size__impl__cvg66t(this.a2t_1);
  }
  f2t() {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(new TGenStack(this.a2t_1)).g1()) {
      tmp = TGenStack__pop_impl_qisxa0(this.a2t_1);
    } else {
      var _unary__edvuaz = this.b2t_1;
      this.b2t_1 = _unary__edvuaz + 1 | 0;
      tmp = this.z2s_1(_unary__edvuaz);
    }
    return tmp;
  }
  e3() {
    TGenStack__clear_impl_pali4s(this.a2t_1);
    this.b2t_1 = 0;
  }
  g2t(element) {
    this.y2s_1(element);
    TGenStack__push_impl_9yh33t(this.a2t_1, element);
  }
  h2t(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      this.g2t(element);
    }
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.a2t_1);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.a2t_1, other.a2t_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.e2t() === other.e2t();
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ConcurrentPool extends Pool {
  static p2t(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = this.c2t(reset, preallocate, gen);
    $this.m2t_1 = reset;
    $this.n2t_1 = gen;
    $this.o2t_1 = new NonRecursiveLock();
    return $this;
  }
  f2t() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.o2t_1.a1x_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.datastructure.ConcurrentPool.alloc.<anonymous>' call
    return super.f2t();
  }
  e3() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.o2t_1.a1x_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.e3();
  }
  g2t(element) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.o2t_1.a1x_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    super.g2t(element);
  }
}
class ReturnablePool {
  constructor(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.q2t_1 = _reset;
    this.r2t_1 = gen;
    this.s2t_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.t2t_1 = Pool.c2t(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.u2t_1 = this.t2t_1.f2t();
  }
  c1() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.s2t_1;
    var element = this.u2t_1;
    this_0.h(element);
    this.u2t_1 = this.t2t_1.f2t();
    return this.u2t_1;
  }
  v2t() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.s2t_1.sz_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.datastructure.ReturnablePool.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.t2t_1.g2t(it);
    }
    this.s2t_1.e3();
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.w2t_1 = function_0;
  }
  xi(a, b) {
    return this.w2t_1(a, b);
  }
  compare(a, b) {
    return this.xi(a, b);
  }
  h4() {
    return this.w2t_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.h4(), other.h4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h4());
  }
}
class Companion_8 {
  x2t(comparator, reversed_0) {
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = fillArrayVal(Array(16), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  }
  y2t(reversed, comparator) {
    return Companion_instance_8.x2t(new sam$kotlin_Comparator$0(comparator), reversed);
  }
  z2t(reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.y2t(reversed, comparator) : $super.y2t.call(this, reversed, comparator);
  }
}
class TGenPriorityQueue$iterator$1 {
  constructor($index, this$0) {
    this.d2u_1 = $index;
    this.e2u_1 = this$0;
  }
  b1() {
    return this.d2u_1._v < this.e2u_1.c2u_1;
  }
  c1() {
    var _unary__edvuaz = this.d2u_1._v;
    this.d2u_1._v = _unary__edvuaz + 1 | 0;
    return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(_unary__edvuaz), this.e2u_1);
  }
  h1c() {
    throw NotImplementedError.ud();
  }
  k6() {
    return this.h1c();
  }
}
class TGenPriorityQueue {
  constructor(data, comparator) {
    this.a2u_1 = data;
    this.b2u_1 = comparator;
    this.c2u_1 = 0;
  }
  e1() {
    return this.c2u_1;
  }
  f2u() {
    if (this.c2u_1 <= 0)
      throw IndexOutOfBoundsException.fe();
    return this.a2u_1[0];
  }
  w2p(element) {
    this.c2u_1 = this.c2u_1 + 1 | 0;
    ensure_1(this, this.c2u_1);
    var i = _PriorityQueueNode___init__impl__34dlfu(this.c2u_1 - 1 | 0);
    _set_value__lx0xdg(i, this, element);
    while (!_get_isRoot__1006zj(i, this) && gt(this, _get_value__a43j40(_get_parent__oo9xup(i, this), this), _get_value__a43j40(i, this))) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    return true;
  }
  h(element) {
    return this.w2p((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  g2u() {
    if (this.c2u_1 <= 0)
      throw IndexOutOfBoundsException.fe();
    if (this.c2u_1 === 1) {
      this.c2u_1 = this.c2u_1 - 1 | 0;
      return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    }
    var root = _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    _set_value__lx0xdg(_PriorityQueueNode___init__impl__34dlfu(0), this, _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(this.c2u_1 - 1 | 0), this));
    this.c2u_1 = this.c2u_1 - 1 | 0;
    minHeapify(this, 0);
    return root;
  }
  y2p(element) {
    var inductionVariable = 0;
    var last = this.c2u_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.a2u_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  x2p(element) {
    var index = this.y2p(element);
    if (index >= 0) {
      this.h2u(index);
    }
    return index >= 0;
  }
  g3(element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.x2p((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  h2u(index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    while (!(_PriorityQueueNode___get_index__impl__b6r7i5(i) === 0)) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    this.g2u();
  }
  z2p(elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.datastructure.TGenPriorityQueue.containsAll.<anonymous>' call
        if (!thisSet.s2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  t2(elements) {
    return this.z2p(elements);
  }
  g1() {
    return this.c2u_1 === 0;
  }
  s2p(elements) {
    var _iterator__ex2g4s = elements.a1();
    while (_iterator__ex2g4s.b1()) {
      var e = _iterator__ex2g4s.c1();
      this.w2p(e);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !elements.g1();
  }
  f1(elements) {
    return this.s2p(elements);
  }
  a1() {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  }
  toString() {
    return toString(toList(this));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_1(this.a2u_1, other.a2u_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.b2u_1, other.b2u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_1(this.a2u_1);
  }
}
class TGenQueue {
  constructor() {
    this.i2u_1 = TGenDeque.p2p();
  }
  e1() {
    return this.i2u_1.e1();
  }
  g1() {
    return this.e1() === 0;
  }
  j2u(v) {
    this.i2u_1.q2p(v);
  }
  k2u() {
    return this.i2u_1.rk();
  }
  z2p(elements) {
    return this.i2u_1.z2p(elements);
  }
  t2(elements) {
    return this.z2p(elements);
  }
  a1() {
    return this.i2u_1.a1();
  }
  hashCode() {
    return this.i2u_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.i2u_1.equals(other.i2u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Ref$1 {
  l2u(_set____db54di) {
    this.m2u_1 = _set____db54di;
  }
  n1() {
    var tmp = this.m2u_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  }
}
class Ref$2 {
  constructor($prop) {
    this.n2u_1 = $prop;
  }
  l2u(value) {
    this.n2u_1.set(value);
  }
  n1() {
    return this.n2u_1.get();
  }
}
class ByteRingBuffer {
  constructor(bits) {
    this.y2l_1 = bits;
    this.z2l_1 = 1 << this.y2l_1;
    this.a2m_1 = this.z2l_1 - 1 | 0;
    this.b2m_1 = new Int8Array(this.z2l_1);
    this.c2m_1 = 0;
    this.d2m_1 = 0;
    this.e2m_1 = this.z2l_1;
    this.f2m_1 = 0;
  }
  e15() {
    return this.b2m_1;
  }
  f15() {
    return this.c2m_1 & this.a2m_1;
  }
  g15() {
    return this.d2m_1 & this.a2m_1;
  }
  h15(count) {
    if (count < 0 || count > this.e2m_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.a5(toString(message));
    }
    this.d2m_1 = this.d2m_1 + count | 0;
    this.f2m_1 = this.f2m_1 + count | 0;
    this.e2m_1 = this.e2m_1 - count | 0;
  }
  i15(count) {
    if (count < 0 || count > this.f2m_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.a5(toString(message));
    }
    this.c2m_1 = this.c2m_1 + count | 0;
    this.f2m_1 = this.f2m_1 - count | 0;
    this.e2m_1 = this.e2m_1 + count | 0;
  }
  j15() {
    // Inline function 'kotlin.math.min' call
    var a = this.f2m_1;
    var b = this.z2l_1 - (this.c2m_1 & this.a2m_1) | 0;
    return Math.min(a, b);
  }
  k15() {
    // Inline function 'kotlin.math.min' call
    var a = this.e2m_1;
    var b = this.z2l_1 - (this.d2m_1 & this.a2m_1) | 0;
    return Math.min(a, b);
  }
  m2m(consume) {
    while (consume.f2m_1 > 0) {
      // Inline function 'kotlin.math.min' call
      var a = consume.j15();
      var b = this.k15();
      var copySize = Math.min(a, b);
      Memory_instance.o2u(consume.e15(), consume.f15(), this.e15(), this.g15(), copySize);
      consume.i15(copySize);
      this.h15(copySize);
    }
  }
  x14(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.e2m_1;
    var remaining = Math.min(a, size);
    var coffset = offset;
    var totalWrite = 0;
    $l$loop: while (remaining > 0) {
      // Inline function 'kotlin.math.min' call
      var a_0 = remaining;
      var b = this.k15();
      var chunkSize = Math.min(a_0, b);
      if (chunkSize <= 0)
        break $l$loop;
      Memory_instance.o2u(data, coffset, this.b2m_1, this.g15(), chunkSize);
      this.h15(chunkSize);
      coffset = coffset + chunkSize | 0;
      remaining = remaining - chunkSize | 0;
      totalWrite = totalWrite + chunkSize | 0;
    }
    return totalWrite;
  }
  m15(size) {
    // Inline function 'kotlin.math.min' call
    var a = this.f2m_1;
    var toRead = Math.min(a, size);
    this.c2m_1 = (this.c2m_1 + toRead | 0) & this.a2m_1;
    this.e2m_1 = this.e2m_1 + toRead | 0;
    this.f2m_1 = this.f2m_1 - toRead | 0;
    return toRead;
  }
  l15(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.f2m_1;
    var toRead = Math.min(a, size);
    var readCount = 0;
    var buffer = this.b2m_1;
    var mask = this.a2m_1;
    var coffset = offset;
    var lReadPos = this.c2m_1;
    $l$loop: while (true) {
      // Inline function 'kotlin.math.min' call
      var a_0 = toRead;
      var b = this.j15();
      var toReadChunk = Math.min(a_0, b);
      if (toReadChunk <= 0)
        break $l$loop;
      Memory_instance.o2u(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  }
  e3() {
    this.c2m_1 = 0;
    this.d2m_1 = 0;
    this.f2m_1 = 0;
    this.e2m_1 = this.z2l_1;
  }
  o15(offset) {
    return this.b2m_1[(this.c2m_1 + offset | 0) & this.a2m_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ByteRingBuffer) {
      tmp_0 = this.f2m_1 === other.f2m_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.f2m_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.ByteRingBuffer.equals.<anonymous>' call
            if (!(this.o15(n) === other.o15(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.z14();
  }
  z14() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.f2m_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.ByteRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.o15(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class RingBuffer extends ByteRingBuffer {}
class ShortRingBuffer {
  constructor(bits) {
    this.o2m_1 = bits;
    this.p2m_1 = 1 << this.o2m_1;
    this.q2m_1 = this.p2m_1 - 1 | 0;
    this.r2m_1 = new Int16Array(this.p2m_1);
    this.s2m_1 = 0;
    this.t2m_1 = 0;
    this.u2m_1 = this.p2m_1;
    this.v2m_1 = 0;
    this.w2m_1 = new Int16Array(1);
  }
  d2n(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.u2m_1;
    var toWrite = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.r2m_1[this.t2m_1] = data[offset + n | 0];
        this.t2m_1 = (this.t2m_1 + 1 | 0) & this.q2m_1;
      }
       while (inductionVariable < toWrite);
    this.v2m_1 = this.v2m_1 + toWrite | 0;
    this.u2m_1 = this.u2m_1 - toWrite | 0;
    return toWrite;
  }
  c2n(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.v2m_1;
    var toRead = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this.r2m_1[this.s2m_1];
        this.s2m_1 = (this.s2m_1 + 1 | 0) & this.q2m_1;
      }
       while (inductionVariable < toRead);
    this.u2m_1 = this.u2m_1 + toRead | 0;
    this.v2m_1 = this.v2m_1 - toRead | 0;
    return toRead;
  }
  e3() {
    this.s2m_1 = 0;
    this.t2m_1 = 0;
    this.v2m_1 = 0;
    this.u2m_1 = this.p2m_1;
  }
  o15(offset) {
    return this.r2m_1[(this.s2m_1 + offset | 0) & this.q2m_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ShortRingBuffer) {
      tmp_0 = this.v2m_1 === other.v2m_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.v2m_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.ShortRingBuffer.equals.<anonymous>' call
            if (!(this.o15(n) === other.o15(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.z14();
  }
  z14() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.v2m_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.ShortRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.o15(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class Companion_9 {}
class TGenStack {
  constructor(items) {
    this.p2u_1 = items;
  }
  e1() {
    return _TGenStack___get_size__impl__cvg66t(this.p2u_1);
  }
  g1() {
    return TGenStack__isEmpty_impl_bsbpyi(this.p2u_1);
  }
  z2p(elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.p2u_1, elements);
  }
  t2(elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  }
  a1() {
    return TGenStack__iterator_impl_2pdia5(this.p2u_1);
  }
  toString() {
    return TGenStack__toString_impl_s9t5hn(this.p2u_1);
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.p2u_1);
  }
  equals(other) {
    return TGenStack__equals_impl_w9i35u(this.p2u_1, other);
  }
}
class SyncPauseable {
  constructor() {
    this.q2u_1 = new Lock();
    this.r2u_1 = false;
  }
  s2u(value) {
    if (!(this.r2u_1 === value)) {
      this.r2u_1 = value;
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.q2u_1;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
        this_0.f1x();
        try {
          this.q2u_1.j1x();
          break $l$block;
        }finally {
          this_0.h1x();
        }
      }
    }
  }
}
class Memory {
  k2p(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var destination = isArray(dst) ? dst : THROW_CCE();
    var endIndex = srcPos + size | 0;
    arrayCopy(src, destination, dstPos, srcPos, endIndex);
  }
  o2u(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  d2o(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  n2n(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  y2o(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
}
class PointList {}
function get_dimensions() {
  return 2;
}
function isEmpty() {
  return this.e1() === 0;
}
function getX(index) {
  return this.f2b(index, 0);
}
function getY(index) {
  return this.f2b(index, 1);
}
function get_1(index) {
  return Vector2D.d2b(this.f2b(index, 0), this.f2b(index, 1));
}
function getComponentList(component, out) {
  var inductionVariable = 0;
  var last = this.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out[n] = this.f2b(n, component);
    }
     while (inductionVariable < last);
  return out;
}
function getComponentList$default(component, out, $super) {
  out = out === VOID ? new Float64Array(this.e1()) : out;
  return $super === VOID ? this.t2u(component, out) : getComponentList(component, out);
}
function get_first() {
  return this.d1(0);
}
function get_last() {
  return this.d1(this.e1() - 1 | 0);
}
function clone(out) {
  out.z2u(this);
  return out;
}
function clone$default(out, $super) {
  out = out === VOID ? new PointArrayList(this.e1()) : out;
  return $super === VOID ? this.v2u(out) : clone(out);
}
class Companion_10 {}
class PointArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.w2u_1 = new Mixin();
    this.x2u_1 = false;
    this.y2u_1 = DoubleArrayList.n2o(imul(capacity, 2));
  }
  cz(_set____db54di) {
    this.w2u_1.cz(_set____db54di);
  }
  dz() {
    return this.w2u_1.dz();
  }
  e1() {
    return this.y2u_1.e1() / 2 | 0;
  }
  f2b(index_0, dim) {
    return this.y2u_1.xy(index(this, index_0, dim));
  }
  b2b(index_0) {
    return this.y2u_1.xy(index(this, index_0, 0));
  }
  c2b(index_0) {
    return this.y2u_1.xy(index(this, index_0, 1));
  }
  d1(index_0) {
    var i = index(this, index_0, 0);
    return Vector2D.d2b(this.y2u_1.xy(i), this.y2u_1.xy(i + 1 | 0));
  }
  eh() {
    this.y2u_1.e3();
    return this;
  }
  b2v(x, y) {
    this.y2u_1.s2o(x, y);
    return this;
  }
  c2v(p) {
    return this.b2v(p.x28_1, p.y28_1);
  }
  d2v(p) {
    return this.e2v(p);
  }
  e2v(p) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < p.e1()) {
      // Inline function 'korlibs.math.geom.PointArrayList.addAll.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = p.d1(_unary__edvuaz);
      var x = destruct.il();
      var y = destruct.jl();
      this.b2v(x, y);
    }
    return this;
  }
  f2v(p, index) {
    this.b2v(p.b2b(index), p.c2b(index));
  }
  z2u(other) {
    this.eh();
    this.d2v(other);
    return this;
  }
  v2u(out) {
    return out.eh().d2v(this);
  }
  j2o(index_0, count) {
    this.y2u_1.j2o(index(this, index_0, 0), imul(count, 2));
    return this;
  }
  g2v(index, count, $super) {
    count = count === VOID ? 1 : count;
    return $super === VOID ? this.j2o(index, count) : $super.j2o.call(this, index, count);
  }
  equals(other) {
    var tmp;
    if (other instanceof PointArrayList) {
      tmp = this.y2u_1.equals(other.y2u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.y2u_1.hashCode();
  }
  toString() {
    var sb = StringBuilder.f();
    sb.vb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _destruct__k2r9zo = this.d1(n);
        var x = _destruct__k2r9zo.il();
        var y = _destruct__k2r9zo.jl();
        if (!(n === 0)) {
          sb.ub(', ');
        }
        sb.vb(_Char___init__impl__6a9atx(40));
        if (x === round(x))
          sb.xg(numberToInt(x));
        else
          sb.ah(x);
        sb.ub(', ');
        if (y === round(y))
          sb.xg(numberToInt(y));
        else
          sb.ah(y);
        sb.vb(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.vb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
  hy(other, epsilon) {
    return this.g2b((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
  t2(elements) {
    return this.z2a(elements);
  }
}
class DoubleVectorArrayList {
  constructor(dimensions, capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.h2v_1 = new Mixin();
    this.i2v_1 = dimensions;
    this.j2v_1 = DoubleArrayList.n2o(imul(capacity, this.i2v_1));
    this.k2v_1 = false;
  }
  cz(_set____db54di) {
    this.h2v_1.cz(_set____db54di);
  }
  dz() {
    return this.h2v_1.dz();
  }
  h2b() {
    return this.i2v_1;
  }
  e1() {
    return this.j2v_1.e1() / this.i2v_1 | 0;
  }
  f2b(index, dim) {
    return this.j2v_1.d1(imul(index, this.i2v_1) + dim | 0);
  }
  s2o(v0, v1) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.j2v_1.s2o(v0, v1);
    return Unit_instance;
  }
  t2o(v0, v1, v2, v3) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.j2v_1.t2o(v0, v1, v2, v3);
    return Unit_instance;
  }
  u2o(v0, v1, v2, v3, v4, v5) {
    // Inline function 'kotlin.also' call
    checkDimensions(this, 6);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.add.<anonymous>' call
    this.j2v_1.u2o(v0, v1, v2, v3, v4, v5);
    return Unit_instance;
  }
  l2v(index, out, roundDecimalPlaces) {
    appendGenericArray(out, this.i2v_1, DoubleVectorArrayList$vectorToStringBuilder$lambda(this, index, roundDecimalPlaces));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof DoubleVectorArrayList) {
      tmp_0 = this.i2v_1 === other.i2v_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.j2v_1.equals(other.j2v_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.j2v_1.hashCode();
  }
  toString() {
    return this.m2v(null);
  }
  m2v(roundDecimalPlaces) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.DoubleVectorArrayList.toString.<anonymous>' call
    this_0.ub('VectorArrayList[' + this.e1() + '](\n');
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.ub(', \n');
        }
        this_0.ub('   ');
        this.l2v(n, this_0, roundDecimalPlaces);
      }
       while (inductionVariable < last);
    this_0.ub('\n)');
    return this_0.toString();
  }
  e3() {
    this.j2v_1.e3();
  }
  hy(other, epsilon) {
    return this.g2b((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
}
class Companion_11 {}
class PointIntArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.n2v_1 = new Mixin();
    this.o2v_1 = false;
    this.p2v_1 = IntArrayList.t2n(capacity);
    this.q2v_1 = IntArrayList.t2n(capacity);
  }
  cz(_set____db54di) {
    this.n2v_1.cz(_set____db54di);
  }
  dz() {
    return this.n2v_1.dz();
  }
  e1() {
    return this.p2v_1.e1();
  }
  g1() {
    return this.e1() === 0;
  }
  e3() {
    this.p2v_1.e3();
    this.q2v_1.e3();
  }
  r2v(x, y) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.PointIntArrayList.add.<anonymous>' call
    this.p2v_1.a2o(x);
    this.q2v_1.a2o(y);
    return this;
  }
  s2v(p) {
    return this.r2v(p.j2i_1, p.k2i_1);
  }
  b2b(index) {
    return this.p2v_1.xy(index);
  }
  c2b(index) {
    return this.q2v_1.xy(index);
  }
  toString() {
    var sb = StringBuilder.f();
    sb.vb(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.b2b(n);
        var y = this.c2b(n);
        if (!(n === 0)) {
          sb.ub(', ');
        }
        sb.vb(_Char___init__impl__6a9atx(40));
        sb.xg(x);
        sb.ub(', ');
        sb.xg(y);
        sb.vb(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.vb(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function ensureWrite($this, count) {
  if (count <= $this.i2m_1.e2m_1)
    return Unit_instance;
  if (!$this.h2m_1) {
    var message = "Can't grow ByteArrayDeque. Need to write " + count + ', but only ' + $this.i2m_1.e2m_1 + ' is available';
    println('ERROR: ' + message);
    // Inline function 'kotlin.error' call
    throw IllegalStateException.a5(toString(message));
  }
  var minNewSize = $this.i2m_1.f2m_1 + count | 0;
  var tmp = $this;
  // Inline function 'kotlin.also' call
  var this_0 = new RingBuffer(ilog2(minNewSize) + 2 | 0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.ByteArrayDeque.ensureWrite.<anonymous>' call
  this_0.m2m($this.i2m_1);
  tmp.i2m_1 = this_0;
}
function ensureWrite_0($this, count) {
  if (count > $this.y2m_1.u2m_1) {
    var minNewSize = $this.y2m_1.v2m_1 + count | 0;
    var newBits = ilog2(minNewSize) + 2 | 0;
    var newRing = new ShortRingBuffer(newBits);
    while ($this.y2m_1.v2m_1 > 0) {
      var read = $this.y2m_1.c2n($this.z2m_1, 0, $this.z2m_1.length);
      newRing.d2n($this.z2m_1, 0, read);
    }
    $this.y2m_1 = newRing;
  }
  return $this;
}
function swap(_this__u8e3s4, lIndex, rIndex) {
  var temp = _this__u8e3s4[lIndex];
  _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
  _this__u8e3s4[rIndex] = temp;
}
function rotateRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure._rotateRight' call
    var size = _this__u8e3s4.length;
    var offset_0 = umod(offset, size);
    if (offset_0 === 0) {
      tmp$ret$0 = Unit_instance;
      break $l$block;
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(1 <= offset_0 ? offset_0 < size : false)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.a5(toString(message));
    }
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, size);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, 0, offset_0);
    // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
    reverse(_this__u8e3s4, offset_0, size);
  }
  return tmp$ret$0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function ensure($this, count) {
  if (($this.h2n_1 + count | 0) > $this.g2n_1.length) {
    var tmp = $this;
    var tmp_0 = $this.g2n_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.h2n_1 + count | 0;
    var b = imul($this.g2n_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf(tmp_0, tmp$ret$0);
    tmp.g2n_1 = isFloatArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function ensure_0($this, count) {
  if (($this.m2o_1 + count | 0) > $this.l2o_1.length) {
    var tmp = $this;
    var tmp_0 = $this.l2o_1;
    // Inline function 'kotlin.math.max' call
    var a = $this.m2o_1 + count | 0;
    var b = imul($this.l2o_1.length, 3);
    var tmp$ret$0 = Math.max(a, b);
    var tmp_1 = copyOf_1(tmp_0, tmp$ret$0);
    tmp.l2o_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
function intArrayListOf(values) {
  return IntArrayList.x2n(values.slice());
}
function toIntArrayList(_this__u8e3s4) {
  return IntArrayList.x2n(_this__u8e3s4.slice());
}
function floatArrayListOf(values) {
  return FloatArrayList.j2n(values.slice());
}
function doubleArrayListOf(values) {
  return DoubleArrayList.q2o(values.slice());
}
function sort(_this__u8e3s4, start, end, reversed) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.e1() : end;
  reversed = reversed === VOID ? false : reversed;
  return genericSort_0(_this__u8e3s4, start, end - 1 | 0, DoubleArrayListSortOps_getInstance(), reversed);
}
function reverse_0(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.e1() : end;
  return DoubleArrayListSortOps_getInstance().b2p(_this__u8e3s4, start, end - 1 | 0);
}
var DoubleArrayListSortOps_instance;
function DoubleArrayListSortOps_getInstance() {
  if (DoubleArrayListSortOps_instance === VOID)
    new DoubleArrayListSortOps();
  return DoubleArrayListSortOps_instance;
}
function _get__data__kyoi3c($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.j2p_1;
}
function _get_capacity__a9k9f3($this) {
  return $this.j2p_1.length;
}
function resizeIfRequiredFor($this, count) {
  if (($this.e1() + count | 0) > _get_capacity__a9k9f3($this)) {
    var i = $this.j2p_1;
    var istart = $this.h2p_1;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.j2p_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.e1() + count | 0;
    var b = imul($this.j2p_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var size = Math.max(a, b_0);
    var _o = fillArrayVal(Array(size), null);
    var o = isArray(_o) ? _o : THROW_CCE();
    copyCyclic($this, i, istart, o, $this.i2p_1);
    $this.j2p_1 = o;
    $this.h2p_1 = 0;
  }
}
function copyCyclic($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.k2p(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.k2p(i, 0, o, size1, size2);
  }
}
function _addLast($this, item) {
  $this.j2p_1[($this.h2p_1 + $this.i2p_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
  $this.i2p_1 = $this.i2p_1 + 1 | 0;
}
function nullify($this, index) {
  _get__data__kyoi3c($this)[index] = null;
}
function internalIndex($this, index) {
  return umod($this.h2p_1 + index | 0, _get_capacity__a9k9f3($this));
}
function _get__data__kyoi3c_0($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.c2q_1;
}
function _get_capacity__a9k9f3_0($this) {
  return $this.c2q_1.length;
}
function resizeIfRequiredFor_0($this, count) {
  if (($this.e1() + count | 0) > _get_capacity__a9k9f3_0($this)) {
    var i = $this.c2q_1;
    var istart = $this.a2q_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = $this.c2q_1.length + 7 | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a_0 = $this.e1() + count | 0;
    var b = imul($this.c2q_1.length, 2);
    var b_0 = Math.max(a_0, b);
    var tmp$ret$1 = Math.max(a, b_0);
    var _o = new Int32Array(tmp$ret$1);
    var o = isIntArray(_o) ? _o : THROW_CCE();
    copyCyclic_0($this, i, istart, o, $this.b2q_1);
    $this.c2q_1 = o;
    $this.a2q_1 = 0;
  }
}
function copyCyclic_0($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.d2o(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.d2o(i, 0, o, size1, size2);
  }
}
function _addLast_0($this, item) {
  $this.c2q_1[($this.a2q_1 + $this.b2q_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
  $this.b2q_1 = $this.b2q_1 + 1 | 0;
}
function nullify_0($this, index) {
  _get__data__kyoi3c_0($this)[index] = 0;
}
function internalIndex_0($this, index) {
  return umod($this.a2q_1 + index | 0, _get_capacity__a9k9f3_0($this));
}
function getAndRemove(_this__u8e3s4, key) {
  // Inline function 'kotlin.also' call
  var this_0 = get_2(_this__u8e3s4, key);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.getAndRemove.<anonymous>' call
  remove(_this__u8e3s4, key);
  return this_0;
}
function get_keys(_this__u8e3s4) {
  return keys(_this__u8e3s4);
}
function translateIndex(_this__u8e3s4, $this) {
  if (!(0 <= _this__u8e3s4 ? _this__u8e3s4 < $this.e1() : false))
    throw IndexOutOfBoundsException.ge('' + _this__u8e3s4);
  return $this.w2q_1 + _this__u8e3s4 | 0;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function IArray2$asString$lambda(this$0) {
  return function (y) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.k2l());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.w1_1;
    var last = this_0.x1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.IArray2.asString.<anonymous>.<anonymous>' call
        var x = item;
        var tmp$ret$0 = this$0.r2l(x, y);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return joinToString(destination, ', ');
  };
}
function indexOr(_this__u8e3s4, x, y, invalid) {
  invalid = invalid === VOID ? -1 : invalid;
  if (!(0 <= x ? x < _this__u8e3s4.k2l() : false) || !(0 <= y ? y < _this__u8e3s4.l2l() : false))
    return invalid;
  return imul(y, _this__u8e3s4.k2l()) + x | 0;
}
function currentKey($this) {
  switch ($this.c2r_1) {
    case 2147483647:
    case 2147483646:
      return 0;
    default:
      return $this.b2r_1.l2r_1[$this.c2r_1];
  }
}
function currentValue($this) {
  switch ($this.c2r_1) {
    case 2147483647:
      return $this.b2r_1.i2r_1;
    case 2147483646:
      return null;
    default:
      return $this.b2r_1.m2r_1[$this.c2r_1];
  }
}
function nextNonEmptyIndex($this, keys, offset) {
  var inductionVariable = offset;
  var last = keys.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(keys[n] === 0))
        return n;
    }
     while (inductionVariable < last);
  return 2147483646;
}
function next($this) {
  if (!($this.c2r_1 === 2147483646))
    $this.c2r_1 = nextNonEmptyIndex($this, $this.b2r_1.l2r_1, $this.c2r_1 === 2147483647 ? 0 : $this.c2r_1 + 1 | 0);
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($it) {
  return function () {
    return $it.p2r();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058($it) {
  return function () {
    return $it.b1();
  };
}
function IntMap$_get_values_$o$iterator$lambda_ggo058_0($it) {
  return function () {
    return $it.q2r();
  };
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function _get_stashStart__3psegu($this) {
  return $this.l2r_1.length - $this.k2r_1 | 0;
}
function grow($this) {
  var inc = $this.e2r_1 < 20 ? 3 : 1;
  var newnbits = $this.e2r_1 + inc | 0;
  var new_0 = IntMap.u2r(newnbits, $this.f2r_1, true);
  var inductionVariable = 0;
  var last = $this.l2r_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.l2r_1[n];
      if (!(k === 0)) {
        new_0.v2r(k, $this.m2r_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.e2r_1 = new_0.e2r_1;
  $this.g2r_1 = new_0.g2r_1;
  $this.j2r_1 = new_0.j2r_1;
  $this.k2r_1 = new_0.k2r_1;
  $this.l2r_1 = new_0.l2r_1;
  $this.m2r_1 = new_0.m2r_1;
  $this.n2r_1 = new_0.n2r_1;
}
function growStash($this) {
  $this.k2r_1 = imul($this.k2r_1, 2);
  $this.l2r_1 = copyOf_0($this.l2r_1, $this.w2r());
  $this.m2r_1 = copyOf_2($this.m2r_1, $this.w2r());
}
function _getKeyIndex($this, key) {
  if (key === 0)
    return $this.h2r_1 ? 2147483647 : -1;
  var index1 = hash1($this, key);
  if ($this.l2r_1[index1] === key)
    return index1;
  var index2 = hash2($this, key);
  if ($this.l2r_1[index2] === key)
    return index2;
  var index3 = hash3($this, key);
  if ($this.l2r_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu($this);
  var last = $this.l2r_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.l2r_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot($this, index, key, value) {
  if (!($this.l2r_1[index] === 0))
    throw IllegalStateException.r5();
  $this.l2r_1[index] = key;
  $this.m2r_1[index] = value;
  $this.o2r_1 = $this.o2r_1 + 1 | 0;
  return null;
}
function hash1($this, key) {
  return _hash1(key, $this.j2r_1);
}
function hash2($this, key) {
  return _hash2(key, $this.j2r_1);
}
function hash3($this, key) {
  return _hash3(key, $this.j2r_1);
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function _get_stashStart__3psegu_0($this) {
  return $this.n2s_1.length - $this.m2s_1 | 0;
}
function grow_0($this) {
  var inc = $this.g2s_1 < 20 ? 3 : 1;
  var newnbits = $this.g2s_1 + inc | 0;
  var new_0 = IntIntMap.r2s(newnbits, $this.h2s_1, true);
  var inductionVariable = 0;
  var last = $this.n2s_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.n2s_1[n];
      if (!(k === 0)) {
        new_0.s2s(k, $this.o2s_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.g2s_1 = new_0.g2s_1;
  $this.i2s_1 = new_0.i2s_1;
  $this.l2s_1 = new_0.l2s_1;
  $this.m2s_1 = new_0.m2s_1;
  $this.n2s_1 = new_0.n2s_1;
  $this.o2s_1 = new_0.o2s_1;
  $this.p2s_1 = new_0.p2s_1;
}
function growStash_0($this) {
  $this.m2s_1 = imul($this.m2s_1, 2);
  $this.n2s_1 = copyOf_0($this.n2s_1, $this.w2r());
  $this.o2s_1 = copyOf_0($this.o2s_1, $this.w2r());
}
function _getKeyIndex_0($this, key) {
  if (key === 0)
    return $this.j2s_1 ? 2147483647 : -1;
  var index1 = hash1_0($this, key);
  if ($this.n2s_1[index1] === key)
    return index1;
  var index2 = hash2_0($this, key);
  if ($this.n2s_1[index2] === key)
    return index2;
  var index3 = hash3_0($this, key);
  if ($this.n2s_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu_0($this);
  var last = $this.n2s_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.n2s_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot_0($this, index, key, value) {
  if (!($this.n2s_1[index] === 0))
    throw IllegalStateException.r5();
  $this.n2s_1[index] = key;
  $this.o2s_1[index] = value;
  $this.q2s_1 = $this.q2s_1 + 1 | 0;
  return 0;
}
function hash1_0($this, key) {
  return _hash1(key, $this.l2s_1);
}
function hash2_0($this, key) {
  return _hash2(key, $this.l2s_1);
}
function hash3_0($this, key) {
  return _hash3(key, $this.l2s_1);
}
function toIntMap(_this__u8e3s4) {
  var out = IntMap.b2s(numberToInt(_this__u8e3s4.e1() * 1.25));
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.l1().a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.m1();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.n1();
    out.v2r(k, v);
  }
  return out;
}
function _hash1(key, mask) {
  return _mask(key, mask);
}
function _hash2(key, mask) {
  return _mask(imul(key, 1294968109), mask);
}
function _hash3(key, mask) {
  return _mask(imul(key, 294969449), mask);
}
function _mask(value, mask) {
  return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
}
function associateByInt(_this__u8e3s4, block) {
  var n = 0;
  var out = IntMap.b2s();
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var it = _iterator__ex2g4s.c1();
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    out.v2r(block(_unary__edvuaz, it), it);
  }
  return out;
}
function Iterator_0(hasNext, next) {
  return new Iterator$1(hasNext, next);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function Pool$_init_$lambda_q3cbhr(it) {
  return Unit_instance;
}
function Pool$_init_$lambda_q3cbhr_0(it) {
  return Unit_instance;
}
function ConcurrentPool$_init_$lambda_gqhtk8(it) {
  return Unit_instance;
}
function ReturnablePool$_init_$lambda_rsm60r(it) {
  return Unit_instance;
}
function ReturnablePool$list$lambda(this$0) {
  return function (it) {
    this$0.q2t_1(it);
    return Unit_instance;
  };
}
function ReturnablePool$list$lambda_0(this$0) {
  return function (it) {
    return this$0.r2t_1(it);
  };
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function _set_value__lx0xdg(_this__u8e3s4, $this, value) {
  $this.a2u_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)] = value;
}
function _get_value__a43j40(_this__u8e3s4, $this) {
  return $this.a2u_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)];
}
function _get_isRoot__1006zj(_this__u8e3s4, $this) {
  return _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) === 0;
}
function _get_parent__oo9xup(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu((_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) - 1 | 0) / 2 | 0);
}
function _get_left__d9qyp0(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 1 | 0);
}
function _get_right__bvz45n(_this__u8e3s4, $this) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 2 | 0);
}
function gt($this, a, b) {
  return $this.b2u_1.compare(a, b) > 0;
}
function lt($this, a, b) {
  return $this.b2u_1.compare(a, b) < 0;
}
function _get_capacity__a9k9f3_1($this) {
  return $this.a2u_1.length;
}
function ensure_1($this, index) {
  if (index >= _get_capacity__a9k9f3_1($this)) {
    var tmp = $this;
    var tmp_0 = copyOf_2($this.a2u_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
    tmp.a2u_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
}
function minHeapify($this, index) {
  var i = _PriorityQueueNode___init__impl__34dlfu(index);
  $l$loop: while (true) {
    var left = _get_left__d9qyp0(i, $this);
    var right = _get_right__bvz45n(i, $this);
    var smallest = i;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(left) < $this.c2u_1 && lt($this, _get_value__a43j40(left, $this), _get_value__a43j40(i, $this)))
      smallest = left;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(right) < $this.c2u_1 && lt($this, _get_value__a43j40(right, $this), _get_value__a43j40(smallest, $this)))
      smallest = right;
    if (!(smallest === i)) {
      swap_0($this, i, smallest);
      i = smallest;
    } else {
      break $l$loop;
    }
  }
}
function swap_0($this, l, r) {
  var temp = _get_value__a43j40(r, $this);
  _set_value__lx0xdg(r, $this, _get_value__a43j40(l, $this));
  _set_value__lx0xdg(l, $this, temp);
}
function _PriorityQueueNode___init__impl__34dlfu(index) {
  return index;
}
function _PriorityQueueNode___get_index__impl__b6r7i5($this) {
  return $this;
}
function Ref(value) {
  // Inline function 'kotlin.also' call
  var this_0 = Ref_0();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.Ref.<anonymous>' call
  this_0.l2u(value);
  return this_0;
}
function toRef(_this__u8e3s4) {
  return Ref_1(_this__u8e3s4);
}
function Ref_0() {
  return new Ref$1();
}
function Ref_1(prop) {
  return new Ref$2(prop);
}
function _TGenStack___init__impl__yynjgt(items) {
  items = items === VOID ? FastArrayList.uz() : items;
  return items;
}
function _get_items__fzd5gv($this) {
  return $this;
}
function _TGenStack___get_size__impl__cvg66t($this) {
  return _get_items__fzd5gv($this).e1();
}
function TGenStack__isEmpty_impl_bsbpyi($this) {
  return _TGenStack___get_size__impl__cvg66t($this) === 0;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function TGenStack__push_impl_9yh33t($this, v) {
  _get_items__fzd5gv($this).h(v);
}
function TGenStack__pop_impl_qisxa0($this) {
  return _get_items__fzd5gv($this).i3(_get_items__fzd5gv($this).e1() - 1 | 0);
}
function TGenStack__clear_impl_pali4s($this) {
  _get_items__fzd5gv($this).e3();
}
function TGenStack__containsAll_impl_ic9i7r($this, elements) {
  return _get_items__fzd5gv($this).t2(elements);
}
function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
  return TGenStack__containsAll_impl_ic9i7r($this.p2u_1, elements);
}
function TGenStack__iterator_impl_2pdia5($this) {
  return _get_items__fzd5gv($this).a1();
}
function TGenStack__toString_impl_s9t5hn($this) {
  return 'TGenStack(items=' + $this.toString() + ')';
}
function TGenStack__hashCode_impl_l04zom($this) {
  return $this.hashCode();
}
function TGenStack__equals_impl_w9i35u($this, other) {
  if (!(other instanceof TGenStack))
    return false;
  var tmp0_other_with_cast = other instanceof TGenStack ? other.p2u_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function contentHashCode_2(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + toRawBits(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_2(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_3(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + _this__u8e3s4[src + n | 0] | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_3(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function contentHashCode_4(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_4(_this__u8e3s4, that, src, dst) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var count = dst - src | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
       while (inductionVariable < count);
    tmp$ret$1 = true;
  }
  return tmp$ret$1;
}
function fill(_this__u8e3s4, value) {
  var inductionVariable = 0;
  var last = _this__u8e3s4.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      _this__u8e3s4[n] = value;
    }
     while (inductionVariable <= last);
}
function linkedHashMapOf(pairs) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.hc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = _destruct__k2r9zo.il();
    var value = _destruct__k2r9zo.jl();
    // Inline function 'kotlin.collections.set' call
    this_0.b3(key, value);
  }
  return this_0;
}
function _BSearchResult___init__impl__em6zam(raw) {
  return raw;
}
function _BSearchResult___get_raw__impl__uyuhf3($this) {
  return $this;
}
function _BSearchResult___get_found__impl__om04iz($this) {
  return _BSearchResult___get_raw__impl__uyuhf3($this) >= 0;
}
function _BSearchResult___get_index__impl__b5kraz($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : -1;
}
function _BSearchResult___get_nearIndex__impl__s8nq43($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : (-_BSearchResult___get_raw__impl__uyuhf3($this) | 0) - 1 | 0;
}
function binarySearch(_this__u8e3s4, v, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.e1() : toIndex;
  // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.genericBinarySearch' call
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) / 2 | 0;
      // Inline function 'korlibs.datastructure.binarySearch.<anonymous>' call
      var mval = compareTo(_this__u8e3s4.xy(mid), v);
      if (mval < 0)
        low = mid + 1 | 0;
      else if (mval > 0)
        high = mid - 1 | 0;
      else {
        tmp$ret$1 = mid;
        break $l$block;
      }
    }
    // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
    tmp$ret$1 = (-low | 0) - 1 | 0;
  }
  return _BSearchResult___init__impl__em6zam(tmp$ret$1);
}
function getCyclic(_this__u8e3s4, index) {
  return _this__u8e3s4.d1(umod(index, _this__u8e3s4.e1()));
}
function toLinkedMap(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.hc();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
  var _iterator__ex2g4s = _this__u8e3s4.a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    var key = _destruct__k2r9zo.il();
    var value = _destruct__k2r9zo.jl();
    // Inline function 'kotlin.collections.set' call
    this_0.b3(key, value);
  }
  return this_0;
}
function getCyclic_0(_this__u8e3s4, index) {
  return _this__u8e3s4[umod(index, _this__u8e3s4.length)];
}
function genericSort(subject, left, right, ops) {
  return genericSort_0(subject, left, right, ops, false);
}
function genericSort_0(subject, left, right, ops, reversed) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.genericSort.<anonymous>' call
  timSort(subject, left, right, ops, reversed);
  return subject;
}
function timSort(arr, l, r, ops, reversed, RUN) {
  RUN = RUN === VOID ? 32 : RUN;
  var n = (r - l | 0) + 1 | 0;
  var progression = step(until(0, n), RUN);
  var inductionVariable = progression.w1_1;
  var last = progression.x1_1;
  var step_0 = progression.y1_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      var tmp = l + i | 0;
      // Inline function 'kotlin.math.min' call
      var a = (i + RUN | 0) - 1 | 0;
      var b = n - 1 | 0;
      var tmp$ret$0 = Math.min(a, b);
      insertionSort(arr, tmp, l + tmp$ret$0 | 0, ops, reversed);
    }
     while (!(i === last));
  var size = RUN;
  while (size < n) {
    var progression_0 = step(until(0, n), imul(2, size));
    var inductionVariable_0 = progression_0.w1_1;
    var last_0 = progression_0.x1_1;
    var step_1 = progression_0.y1_1;
    if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
      do {
        var left = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_0 = size;
        var b_0 = (n - left | 0) - 1 | 0;
        var rize = Math.min(a_0, b_0);
        var mid = (left + rize | 0) - 1 | 0;
        // Inline function 'kotlin.math.min' call
        var a_1 = (left + imul(2, rize) | 0) - 1 | 0;
        var b_1 = n - 1 | 0;
        var right = Math.min(a_1, b_1);
        merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed);
      }
       while (!(left === last_0));
    size = imul(size, 2);
  }
}
function insertionSort(arr, left, right, ops, reversed) {
  var inductionVariable = left + 1 | 0;
  if (inductionVariable <= right)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var m = n - 1 | 0;
      $l$loop: while (m >= left && negateIf(ops.d2p(arr, m, n), reversed) > 0) {
        m = m - 1 | 0;
      }
      m = m + 1 | 0;
      if (!(m === n)) {
        ops.g2p(arr, m, n);
      }
    }
     while (!(n === right));
}
function merge(arr, start, mid, end, ops, reversed) {
  var s = start;
  var m = mid;
  var s2 = m + 1 | 0;
  if (negateIf(ops.d2p(arr, m, s2), reversed) <= 0)
    return Unit_instance;
  while (s <= m && s2 <= end) {
    if (negateIf(ops.d2p(arr, s, s2), reversed) <= 0) {
      s = s + 1 | 0;
    } else {
      ops.g2p(arr, s, s2);
      s = s + 1 | 0;
      m = m + 1 | 0;
      s2 = s2 + 1 | 0;
    }
  }
}
function negateIf(_this__u8e3s4, doNegate) {
  return doNegate ? -_this__u8e3s4 | 0 : _this__u8e3s4;
}
var Memory_instance;
function Memory_getInstance() {
  return Memory_instance;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function index($this, index, offset) {
  return imul(index, 2) + offset | 0;
}
function pointArrayListOf(p0, p1) {
  return (new PointArrayList(2)).c2v(p0).c2v(p1);
}
function pointArrayListOf_0(p0, p1, p2) {
  return (new PointArrayList(3)).c2v(p0).c2v(p1).c2v(p2);
}
function pointArrayListOf_1(p0, p1, p2, p3) {
  return (new PointArrayList(4)).c2v(p0).c2v(p1).c2v(p2).c2v(p3);
}
function checkDimensions($this, dim) {
  if (!(dim === $this.i2v_1)) {
    // Inline function 'kotlin.error' call
    var message = 'Invalid dimensions ' + dim + ' != ' + $this.i2v_1;
    throw IllegalStateException.a5(toString(message));
  }
}
function DoubleVectorArrayList$vectorToStringBuilder$lambda(this$0, $index, $roundDecimalPlaces) {
  return function ($this$appendGenericArray, it) {
    var v = this$0.f2b($index, it);
    appendNice($this$appendGenericArray, !($roundDecimalPlaces == null) ? roundDecimalPlaces(v, $roundDecimalPlaces) : v);
    return Unit_instance;
  };
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
function FastStringMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function FastIntMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function get_size(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function FastIdentityMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function contains(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.has(key);
}
function clear(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.clear();
}
function get_size_0(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function get_2(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.get(key);
}
function set_1(_this__u8e3s4, key, value) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.set(key, value);
}
function remove(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.delete(key);
}
function keys(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = Array_from(_this__u8e3s4.keys());
  return toList_0(tmp$ret$2);
}
function Array_from(value) {
  return Array.from(value);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForInterface(IArray2, 'IArray2', VOID, VOID, [Iterable]);
initMetadataForInterface(IntIArray2, 'IntIArray2', VOID, VOID, [IArray2]);
protoOf(IntArray2).f2b = get;
protoOf(IntArray2).q2l = set;
protoOf(IntArray2).xy = getAt_0;
protoOf(IntArray2).r2l = getAt;
protoOf(IntArray2).s2l = inside;
protoOf(IntArray2).p2l = asString;
initMetadataForClass(IntArray2, 'IntArray2', VOID, VOID, [IntIArray2]);
initMetadataForCompanion(Companion_0);
initMetadataForInterface(FloatIArray2, 'FloatIArray2', VOID, VOID, [IArray2]);
protoOf(FloatArray2).f2b = get_0;
protoOf(FloatArray2).x2l = set_0;
protoOf(FloatArray2).xy = getAt_1;
protoOf(FloatArray2).r2l = getAt;
protoOf(FloatArray2).s2l = inside;
protoOf(FloatArray2).p2l = asString;
initMetadataForClass(FloatArray2, 'FloatArray2', VOID, VOID, [FloatIArray2]);
initMetadataForClass(ByteArrayDeque, 'ByteArrayDeque', ByteArrayDeque);
initMetadataForClass(ShortArrayDeque, 'ShortArrayDeque', ShortArrayDeque);
initMetadataForCompanion(Companion_1);
initMetadataForClass(FloatArrayList, 'FloatArrayList', FloatArrayList.i2n, VOID, [Collection]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(IntArrayList, 'IntArrayList', IntArrayList.t2n, VOID, [Collection]);
initMetadataForCompanion(Companion_3);
protoOf(DoubleArrayList).u2 = listIterator;
initMetadataForClass(DoubleArrayList, 'DoubleArrayList', DoubleArrayList.n2o, VOID, [DoubleList]);
initMetadataForClass(SortOps, 'SortOps');
initMetadataForObject(DoubleArrayListSortOps, 'DoubleArrayListSortOps');
initMetadataForClass(TGenDeque$iterator$1);
initMetadataForClass(TGenDeque, 'TGenDeque', TGenDeque.p2p, VOID, [Collection, MutableIterable]);
initMetadataForClass(IntDeque$iterator$1);
initMetadataForClass(IntDeque, 'IntDeque', IntDeque.h2q, VOID, [Collection, MutableIterable]);
initMetadataForClass(FastSmallSet, 'FastSmallSet', FastSmallSet.s2q);
initMetadataForClass(GenericSubList, 'GenericSubList', VOID, VOID, [KtList]);
initMetadataForClass(GenericListIterator, 'GenericListIterator');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(Iterator, 'Iterator');
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(IntMap, 'IntMap', IntMap.b2s);
initMetadataForCompanion(Companion_6);
initMetadataForClass(IntIntMap, 'IntIntMap', IntIntMap.t2s);
initMetadataForClass(Iterator$1);
initMetadataForCompanion(Companion_7);
initMetadataForClass(Pool, 'Pool');
initMetadataForClass(ConcurrentPool, 'ConcurrentPool');
initMetadataForClass(ReturnablePool, 'ReturnablePool');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(TGenPriorityQueue$iterator$1);
initMetadataForClass(TGenPriorityQueue, 'TGenPriorityQueue', VOID, VOID, [Collection, MutableIterable]);
initMetadataForClass(TGenQueue, 'TGenQueue', TGenQueue, VOID, [Collection]);
initMetadataForClass(Ref$1);
initMetadataForClass(Ref$2);
initMetadataForClass(ByteRingBuffer, 'ByteRingBuffer');
initMetadataForClass(RingBuffer, 'RingBuffer');
initMetadataForClass(ShortRingBuffer, 'ShortRingBuffer');
initMetadataForCompanion(Companion_9);
initMetadataForClass(TGenStack, 'TGenStack', VOID, VOID, [Collection]);
initMetadataForClass(SyncPauseable, 'SyncPauseable', SyncPauseable);
initMetadataForObject(Memory, 'Memory');
initMetadataForInterface(PointList, 'PointList', VOID, VOID, [IDoubleVectorList, IPointList]);
initMetadataForCompanion(Companion_10);
protoOf(PointArrayList).a2v = clone$default;
protoOf(PointArrayList).h2b = get_dimensions;
protoOf(PointArrayList).g1 = isEmpty;
protoOf(PointArrayList).t2u = getComponentList;
protoOf(PointArrayList).u2u = getComponentList$default;
protoOf(PointArrayList).t2p = get_first;
protoOf(PointArrayList).u2p = get_last;
protoOf(PointArrayList).e2b = isNotEmpty;
protoOf(PointArrayList).g2b = isAlmostEquals;
protoOf(PointArrayList).iy = isAlmostEquals$default;
protoOf(PointArrayList).z2a = containsAll;
protoOf(PointArrayList).a1 = iterator;
protoOf(PointArrayList).u2 = listIterator_0;
protoOf(PointArrayList).v2 = listIterator_1;
protoOf(PointArrayList).w2 = subList;
initMetadataForClass(PointArrayList, 'PointArrayList', PointArrayList, VOID, [PointList]);
protoOf(DoubleVectorArrayList).g2b = isAlmostEquals;
protoOf(DoubleVectorArrayList).iy = isAlmostEquals$default;
initMetadataForClass(DoubleVectorArrayList, 'DoubleVectorArrayList', VOID, VOID, [IDoubleVectorList]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(PointIntArrayList, 'PointIntArrayList', PointIntArrayList);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_4 = new Companion_4();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Memory_instance = new Memory();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
//endregion
//region block: exports
export {
  _BSearchResult___init__impl__em6zam as _BSearchResult___init__impl__em6zam3kgjdixysmohf,
  _BSearchResult___get_found__impl__om04iz as _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o,
  _BSearchResult___get_index__impl__b5kraz as _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci,
  _BSearchResult___get_nearIndex__impl__s8nq43 as _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2,
  _TGenStack___init__impl__yynjgt as _TGenStack___init__impl__yynjgt2kqnbzr6sil9y,
  TGenStack__pop_impl_qisxa0 as TGenStack__pop_impl_qisxa01c9hqlgdxaps5,
  TGenStack__push_impl_9yh33t as TGenStack__push_impl_9yh33t21dxxdiycat5m,
  Companion_instance_0 as Companion_instance3ldriv9x4zcjm,
  Companion_instance as Companion_instancelqpzd9anuk16,
  Companion_instance_8 as Companion_instance2r8kc48nhvjcq,
  SyncPauseable as SyncPauseable20rt0nt3umu2s,
  ByteArrayDeque as ByteArrayDeque2dezgzzyyl6zm,
  ConcurrentPool as ConcurrentPool3ky1e4r5za9ab,
  DoubleArrayList as DoubleArrayList3by0we6lhx26x,
  FastIdentityMap as FastIdentityMap17d14y8i3m5g7,
  FastIntMap as FastIntMapl0pzyavg6uw5,
  FastSmallSet as FastSmallSet2og2j8v2pz4c7,
  FastStringMap as FastStringMap1l1uzdhsfbatm,
  FloatArray2 as FloatArray2beehiaucxmzd,
  GenericListIterator as GenericListIterator397gjg9p2xwl5,
  GenericSubList as GenericSubList2rec7qqyf06nw,
  IntArray2 as IntArray23680o40e0fgt8,
  IntArrayList as IntArrayList3liuagbdnwmna,
  IntDeque as IntDeque2ebok66x2sofm,
  IntIntMap as IntIntMap3mvg5iqgd5t3z,
  IntMap as IntMap2d9g6f5pyaoc2,
  Pool as Pool1zbsw0zhvh8ca,
  Ref_0 as Ref11k43t82thcp3,
  Ref as Ref2y4j4snnxo6gs,
  ReturnablePool as ReturnablePool3rkgvxsckx2u2,
  ShortArrayDeque as ShortArrayDeque13dn2tr6asm80,
  SortOps as SortOps3rp25tm4jbjru,
  TGenQueue as TGenQueue2v9j3ju90xgpv,
  associateByInt as associateByInt3vmv30txx5avl,
  binarySearch as binarySearch1lxbagta5e4q4,
  clear as clear3idbm40uzyume,
  contains as containsrsn76oa0puwr,
  doubleArrayListOf as doubleArrayListOfkj3z9zq4pobs,
  floatArrayListOf as floatArrayListOfa8snvg2p0fhc,
  genericSort as genericSort3vhmyxbppxo3h,
  getAndRemove as getAndRemove1ksxnnren48mb,
  getCyclic_0 as getCyclic18d9063nmuul,
  getCyclic as getCyclic28wvgqye98jqx,
  get_2 as get2pw1zlgv5zypd,
  intArrayListOf as intArrayListOf18h0hna7wb0zr,
  get_keys as get_keyswqddktl7cnu2,
  linkedHashMapOf as linkedHashMapOf2w2uhgrq4khrk,
  reverse_0 as reverse22fe0u1pwl2c6,
  rotateRight as rotateRight96vk8nw2c6nx,
  set_1 as set2vuztm9k7ubgo,
  get_size_0 as get_size2tttv7g2u748n,
  get_size as get_size3oaoh8cpamcqc,
  sort as sort23bpsawysis6n,
  swap as swap3upf401qn4fc8,
  toIntArrayList as toIntArrayList3jlt4o6tyleu,
  toIntMap as toIntMapp1jij98esrcm,
  toRef as toRef3av6zm8yavumw,
  DoubleVectorArrayList as DoubleVectorArrayListq54dfthnqi2t,
  PointArrayList as PointArrayList281mrsgyr6ua1,
  PointIntArrayList as PointIntArrayList1s7gare9hr1oh,
  pointArrayListOf_1 as pointArrayListOf36sb9r6prgwk4,
  pointArrayListOf_0 as pointArrayListOf2s9je3njyg83l,
  pointArrayListOf as pointArrayListOf7rbgdbqf3x4b,
};
//endregion
